import recommendations from "./recommendations";

export default {
    recommendations
}